export default "__VITE_ASSET__DlDVGhO0__"